// extracted by mini-css-extract-plugin
module.exports = {"title":"ResidentProfile_title__P0fdv"};